export default {
  DEV_MODE: process.env.NODE_ENV !== 'production',
  API_BASE_URL: process.env.VUE_APP_PRODUCTION === 'true' ?
    '//api.ebiseo.com' : '//api-dev.ebiseo.com',
}
console.log(process.env.VUE_APP_PRODUCTION)